import React from 'react';
//import { useSelector, useDispatch } from 'react-redux';


import ProductReservation from "api/ProductReservation";

import ProductReservationModel from 'models/ProductReservation';
import PaginationModel from 'models/Pagination';
import Collection from 'models/Collection';

import {
  LOGIN_SUCCESS,
  LOGOUT,
	HIDE_MODAL,
	MESSAGE_INFO,
	MESSAGE_SUCCES
} from "actions/types";
import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";

import {Overview as ProductReservationOverview} from 'views/productreservation/Overview';

class ProductReservationOverviewController extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {error: null,isLoaded: false,items: [], pagination: new ProductReservationModel()};
		//navigate('/', { replace: true })
	}
	
	componentDidMount() {
		this.getData();
	}

	hello =((event, itemObj) => {
		event.preventDefault();
	});

	storeNewStateForReservation =async(data) => {
		console.log( data );
/*		
		const api = new Product();
		let response = await api.setProductState(data);
		const { dispatch } = this.props;
		if(response.status == 200) {
			dispatch({type: HIDE_MODAL});
			dispatch({ type: MESSAGE_SUCCES, "message": "Nieuwe productstatus is opgeslagen", "header": "Product status wijziging" });
			this.getData();
		}
*/		
	}


	getData = (page = 0) => {
		const { dispatch } = this.props;
		dispatch(showLoader());
		const { pagination } = this.state;
		ProductReservation.getProductsReservations(page)
			.then((response) =>   {
				pagination.addData(response.data.data);
				console.log( response.data.data.data );
			this.setState({
				isLoaded: true,
				items: (new Collection()).addData(response.data.data.data, new ProductReservationModel() )
			});
			dispatch(hideLoader());
		})
		.catch(() => {
			dispatch(hideLoader());
		});
	}

	render() {
	const { items, pagination } = this.state;
	return <ProductReservationOverview items={items} pagingEventHandler={this.getData} pagination={pagination} storeNewStateForReservation={this.storeNewStateForReservation}/>;
	}

}

function mapStateToProps(state) {
  const { isLoggedIn } = state.auth;
  return {
    isLoggedIn,
  };
}

export default connect(mapStateToProps)(ProductReservationOverviewController);